import { render, staticRenderFns } from "./DashboardRedesign.vue?vue&type=template&id=0de907f0&"
import script from "./DashboardRedesign.vue?vue&type=script&lang=js&"
export * from "./DashboardRedesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports